export default __webpack_public_path__ + "static/media/slice-app-large.a6491733.jpg";